import { Directive, Input, inject } from '@angular/core';
import { AllDetailsService } from './all-details.service';
import {DataService} from "../../../services/data.service";

export type Appearance = ('table' | 'list')

@Directive()
export class AllDetailsDirective{
  public ds = inject(DataService);
  public as = inject(AllDetailsService);

  @Input() showGroupLabels = true;
  @Input() showUnderlines = true;

  @Input() appearance:Appearance = null ;
  @Input() class = '';
  @Input() labelsClass = ' ';
  @Input() valuesClass = 'text-bold';

  @Input() fieldsContainerClass = '';
  @Input() fieldsGroupClass = '';
  @Input() fieldsClass = 'col-md-6 py-2';
  @Input() fieldsInnerClass = 'd-flex flex-column justify-content-between';

  @Input() arraysContainerClass = '';
  @Input() arrayTablesClass = 'my-1';
  @Input() arrayFieldsClass = '';

  @Input() tableHeadersClass = 'border-bottom';
  @Input() tableCellsClass = 'p-2';
  @Input() tableIndexCellsClass = 'p-2 width-40 faded';
  @Input() tableHeaderCellsClass = '';
  @Input() tableRowsClass = '';

  @Input() groupLabelsClass = 'my-2 mt-3 text-uppercase faded ms-2 ps-1';

  setAppearance(){
    if(this.fieldsClass?.includes('no-underline')) this.showUnderlines = false;

    if(this.ds.valueIncludes(this.appearance,'table')){
      this.showUnderlines = false;

      this.labelsClass='label-value bg-light-faded h-100 col-5 m-0 padding-12 d-flex align-items-center';
      this.valuesClass='label-title h-100 col-7 padding-12 m-0 d-flex align-items-center';
      this.groupLabelsClass='text-bold text-dark max-width-480 rounded-slight text-uppercase faded left--10';

      this.fieldsClass = `${this.as.preserveClass(this.fieldsClass,'col-')} px-0`;
      this.fieldsInnerClass='row mx-0 my-0 border-slightly-faded border-top-0 align-items-center h-100';
      this.fieldsGroupClass='border-top-primary_ mt-2';

      this.tableHeadersClass='border-bottom-primary_ text-dark bg-gradient-light-transparent';
      this.tableRowsClass='bg-even-light border-bottom-slightly-faded last-no-border';
      this.tableHeaderCellsClass='padding-11';
      this.tableCellsClass='max-width-300 padding-11 border-slightly-faded padding-10 border-bottom-0 last-border-right-0';

      this.arrayFieldsClass = 'rounded-slight mb-4';
      this.arraysContainerClass='mt-4';
    }

    if(this.ds.valueIncludes(this.appearance,'list')){
      this.showUnderlines = true;
      this.fieldsClass=`${this.as.preserveClass(this.fieldsClass,'col-')} py-0`;
      this.fieldsInnerClass='d-flex flex-column justify-content-between';
      this.labelsClass='label-title';
      this.valuesClass='label-value';
    }

  }
}
